import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { Owned } from '../base/named';
import { DataFlowColumn } from '../dataset/dataflowcolumn';
import { BaseSchemaModifierTransformation } from './base-schema-modifier-transformation';
import { DataFlowTypesUtils } from './dataflow-type-utilities';
import { IResourceContext } from 'app/multi-contexts/resource-context.typings';

@Metamodel.model({
    name: 'cast',
    display: [stringResources.DataFlowCastTransformationLabel, stringResources.DataFlowCastTransformationsLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        }
    }
})
export class CastTransformation extends BaseSchemaModifierTransformation {
    public static readonly MODEL: IModel;

    public errors: boolean = true;

    public castColumns: DataFlowColumn[] = [];

    public get columns(): DataFlowColumn[] {
        const columns: DataFlowColumn[] = [];
        this.overwrittenColumns = [];
        this.newColumns = [];
        this.unchangedColumns = [];
        for (const column of this.inputColumns) {
            const overwrittenColumnIndex = this.castColumns.findIndex((genColumn) => (genColumn.name) === column.name);
            if (overwrittenColumnIndex > -1
                && (this.castColumns[overwrittenColumnIndex].dataFlowColumnType.typeInDsl !== column.dataFlowColumnType.typeInDsl)) {
                const overwrittenColumn = this.castColumns[overwrittenColumnIndex];
                if (columns.indexOf(overwrittenColumn) < 0) {
                    columns.push(overwrittenColumn);
                }
                if (this.overwrittenColumns.indexOf(overwrittenColumn) < 0) {
                    this.overwrittenColumns.push(overwrittenColumn);
                }
            } else {
                this.unchangedColumns.push(column);
                columns.push(column);
            }
        }
        return columns;
    }

    public initializeTransformation(contextData: IResourceContext): void {
        if (!this.castColumns.length) {
            this.addCastColumn();
        } else {
            this.updateCastColumns();
        }
    }

    public updateCastColumns(): void {
        const updatedCastColumns: DataFlowColumn[] = [];
        this.distinctInputColumnRefs.forEach((columnRef) => {
            const existingColumn = this.castColumns.find((castColumn) => castColumn.name === columnRef.column.name);
            if (existingColumn){
                updatedCastColumns.push(existingColumn);
            }
        });

        if (!updatedCastColumns.length) {
            this.castColumns = [];
            this.addCastColumn();
        } else {
            this.castColumns = updatedCastColumns;
        }
    }

    public addCastColumn(): void {
        const columnRef = this.distinctInputColumnRefs.find((columnRef) => !(this.castColumns.map((column) => column.name)).includes(columnRef.column.name));
        if (columnRef) {
            const dataflowColumn = Owned.create<DataFlowColumn>(Metamodel.modelFor(DataFlowColumn), this);
            dataflowColumn.name = columnRef.column.name;
            dataflowColumn.dataFlowColumnType = DataFlowTypesUtils.cloneType(columnRef.column.dataFlowColumnType);
            this.castColumns.push(dataflowColumn);
        }
    }

    protected getGeneratedDescription(): string {
        return stringResources.CastTransformationDescription;
    }
}
